var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ShippersDeclarationComponent',{attrs:{"item":_vm.declaration}})
}
var staticRenderFns = []

export { render, staticRenderFns }